// src/faqs.js
import { Navigate } from 'react-router-dom';

import './App.css';

const faqs = () => {
  return (
    
    <div className="about-page">

      {/* Hero Section */}
    <section className="heronew">
     <img src="img/blogleft.png" className="vectorall-left desktopvector" alt="left vector" />
  <img src="img/m2.png" className="vectorall-left mobilevector" alt="left vector" />
  
  <div className="hero-content">
  <h1 className="headline">
  <span style={{ color: '#2F2F2F' }}>Frequently asked questions</span>
</h1>

  </div>


</section>

  {/* How we got started */}
      <section className="faqs-section">
        <h2 className='newsection'>Do you deliver on Sundays?</h2>
        <p>We do not deliver on Sundays. Additionally, any non-delivery days such as national or public holidays will be communicated in advance by Paushtikk Switch.</p>

      </section>

        <section className="faqs-section">
        <h2 className='newsection'>Can I pause my subscription indefinitely?</h2>
        <p>You have 20 extra days to complete any subscription plan. If you don't finish the plan within this period, the remaining meals will expire and cannot be reinstated.</p>

      </section>
        <section className="faqs-section">
        <h2 className='newsection'>What are the delivery slots?</h2>
        <p>Lunch Delivery Slot: 11:00 am - 1:30 pm<br/> Dinner Delivery Slot: 6:00 pm - 8:30 pm</p>

      </section>

        <section className="faqs-section">
        <h2 className='newsection'>How soon should I consume the meal after delivery?</h2>
        <p>We recommend consuming your meal 15-20 minutes after delivery. If you choose to preserve the meal, it should be consumed within 6-8 hours.</p>

      </section>
        <section className="faqs-section">
        <h2 className='newsection'>What if I want to cancel or skip a meal?</h2>
        <p>According to our policy, you must inform us by 7 PM the day before if you wish to cancel or skip any meal (Lunch/Dinner). Cancellations made after this time will not be carried forward.</p>

      </section>

         <section className="faqs-section">
        <h2 className='newsection'>How are dislikes and allergies handled?</h2>
        <p>If you have any food allergies or dislikes, Paushtikk Switch will address them if within our scope. You must mention these allergies before subscribing and making the payment. For example, if you are allergic to capsicum, we can remove it if it's separable. However, we do not guarantee this service and do not charge extra for it. While we strive to avoid allergens, we are not responsible for packing errors. Meal compensation can be claimed, but Paushtikk Switch is not liable for any punitive or medical damages.</p>

      </section>

  <section className="faqs-section">
        <h2 className='newsection'>What if there is an issue with the food or delivery?</h2>
        <p>Paushtikk Switch will consider meal compensation under the following conditions:<br/>
        - Quality issues (e.g., undercooked, overcooked, foul smell, foreign objects)<br/>
        - Quantity issues (food not as per the quantity specified)<br/>
        - Late delivery beyond the buffer time of half an hour<br/>
        - Non-delivery due to rider issues<br/>
        - Completely destroyed packaging<br/>
        - Allergies/dislikes not adhered to by the packing team <br/>
        Changes to the delivery address made after the meal change time will not be eligible for compensation. Deliveries affected by Acts of God (e.g., floods, road blockages) are also not eligible. Proof in the form of images/videos is required to escalate issues with our Quality Control Team. Compensation is not provided for personal taste preferences. All compensation decisions are made by the Paushtikk QC team based on evidence submitted.</p>

      </section>

       <section className="faqs-section">
        <h2 className='newsection'>What is the refund policy?</h2>
        <p>- No refunds will be issued once more than 50% of the meals in the plan have been consumed.<br/>- For refunds (if less than 50% of the meals have been consumed), the amount will be calculated as follows:Refund Amount = Total Price - [(Per meal price quoted + Rs 50) x (number of meals consumed)] - tax (5% of Total Price)<br/>- Refunds are not available for plans with a subscription tenure of less than 15 days.<br/>- Refunds will be processed within 15-20 working days* after receiving account details.<br/>- Refunds are not issued if the frequency of plans is updated during your subscription (e.g., changing from Lunch & Dinner to Lunch & Dinner). Instead, your meal plan subscription tenure will be extended accordingly.<br/>- Refunds cannot be claimed if more than 10 meals have been skipped before requesting the refund.</p>

      </section>
    </div>
  );
};
export default faqs;